<template>
  <div>
    <div class="row row-cols-1 row-cols-md-2 g-1">
      <div class="col">
        <div class="content-block">
          <div class="dx-card responsive-paddings">
            <p class="text-muted font-weight-light">Konfigurasi Dokumen</p>

            <DxValidationGroup ref="refValidation" class="form-group">
              <DxSelectBox
                :items="templateDokumenSource"
                valueExpr="val"
                displayExpr="name"
                v-model="templateDokumenSelected"
                label="Template Dokumen"
                :styling-mode="stylingMode"
                :label-mode="labelMode"
                :label-location="labelLocation"
                @selectionChanged="handleTemplateDokumenChange"
              >
                <DxValidator>
                  <DxRequiredRule />
                </DxValidator>
              </DxSelectBox>

              <DxTextBox
                :styling-mode="stylingMode"
                :label-mode="labelMode"
                :label-location="labelLocation"
                width="100%"
                label="Nomor Surat"
                v-model="noSurat"
              >
                <DxValidator>
                  <DxRequiredRule />
                </DxValidator>
              </DxTextBox>

              <DxDateBox
                :styling-mode="stylingMode"
                :label-mode="labelMode"
                :label-location="labelLocation"
                :display-format="'dd/MM/yyyy'"
                width="100%"
                placeholder="Tanggal Surat"
                label="Tanggal Surat"
                v-model="tglSurat"
              >
                <DxValidator>
                  <DxRequiredRule />
                </DxValidator>
              </DxDateBox>

              <div class="d-flex align-items-center" style="margin-top: 30px">
                <div :class="{ 'text-red': isRed }">Pilih Pegawai</div>
                <DxButton
                  text="Clear Pegawai"
                  :icon="'remove'"
                  style="margin-bottom: 0px; margin-left: 20px; float: right"
                  @click="clearPegawai"
                />
              </div>
              <DxList
                v-model:selected-item-keys="selectedPegawaiIds"
                :data-source="pegawaiSource"
                :height="300"
                :search-enabled="true"
                search-mode="contains"
                search-expr="nama"
                :show-selection-controls="true"
                selection-mode="multiple"
                :select-by-click="true"
                @itemClick="handlePegawaiClick"
                @selectionChanged="handlePegawaiClick"
                label="Pilih Pegawai"
              >
                <template #item="{ data }">
                  <div>
                    <div>{{ data.nama }}</div>
                  </div>
                </template>
              </DxList>
              <div :class="{ 'text-red': isRed }">
                <span>Pegawai yang dipilih: </span>
                <span class="bold-text">{{ showPegawai }} </span>
              </div>
              <DxButton
                @click="preview"
                text="Preview Dokumen"
                type="default"
                style="float: right"
                :icon="'eyeopen'"
                styling-mode="filled"
              />
            </DxValidationGroup>
          </div>
        </div>
      </div>
      <div class="col">
        <div class="content-block">
          <div class="dx-card responsive-paddings">
            <p class="text-muted font-weight-light">Preview Dokumen</p>
            <!-- v-if="
                isPreview &&
                (templateDokumenSelected.includes('kp') ||
                  templateDokumenSelected.includes('kgb')) &&
                selectedPegawaiIds.length > 0
              " -->

            <div v-if="isPreview && selectedPegawaiIds.length > 0">
              <TemplateDocKp
                ref="templateDocKp"
                :pegawais="selectedPegawaiIds"
                :key="childKey"
                :noSurat="noSurat"
                :tglSurat="tglSurat"
                :jenisDokumen="templateDokumenSelected"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<style scoped lang="scss">
.text-red {
  color: red;
}
.form-group {
  display: flex;
  flex-direction: column;
  gap: 16px; /* Adjust the gap as needed */
}
.bold-text {
  font-weight: bold;
}
.flex-container {
  display: flex;
  align-items: center;
}
.label-text {
  font-size: 16px;
  font-weight: 600;
}
.ml-2 {
  margin-left: 20px;
}
.mb-0 {
  margin-bottom: 0;
}
</style>
<script>
import _ from "lodash";
import * as commonFunction from "@/utils/common-function.js";
import notify from "devextreme/ui/notify";
import DxValidationGroup from "devextreme-vue/validation-group";
import { usePegawaiListStore } from "@/stores/views/pegawai-list-store";
import { DxSelectBox } from "devextreme-vue/select-box";
import { DxList } from "devextreme-vue/list";
import { DxButton } from "devextreme-vue/button";
import { useCommonStore } from "@/stores/utility/common-store2";
import { DxValidator, DxRequiredRule } from "devextreme-vue/validator";
import TemplateDocKp from "./TemplateDocKp.vue";
import DxTextBox from "devextreme-vue/text-box";
import DxDateBox from "devextreme-vue/date-box";
import can from "@/haspermission";
export default {
  components: {
    DxSelectBox,
    DxList,
    DxButton,
    DxValidator,
    DxRequiredRule,
    DxValidationGroup,
    TemplateDocKp,
    DxTextBox,
    DxDateBox,
  },
  setup() {
    const pegawaiListStore = usePegawaiListStore();
    const commonStore = useCommonStore();
    return {
      pegawaiListStore,
      commonStore,
      commonFunction,
    };
  },

  data() {
    return {
      noSurat: null,
      tglSurat: commonFunction.getCurrentDate(),
      childKey: 0,
      isRed: false,
      stylingMode: "outlined",
      //outlined, filled, underlined
      labelMode: "floating",
      // "outside" | "static" | "floating" | "hidden"
      labelLocation: "top",
      isPreview: false,
      selectedPegawaiIds: [],
      pegawaiSource: null,
      pegawaiSourceAll: null,
      templateDokumenSelected: null,
      templateDokumenSource: [
        { val: "kgb", name: "Kenaikan Gaji Berkala" },
        { val: "kpReguler", name: "Kenaikan Pangkat Reguler" },
        { val: "kpPenyesuaian", name: "Kenaikan Pangkat Penyesuaian" },
        { val: "kpPilihan", name: "Kenaikan Pangkat Pilihan" },
        { val: "persen80", name: "Pengangkatan Calon Pegawai Tetap (80%)" },
        { val: "persen100", name: "Pengangkatan Pegawai Tetap (100%)" },
      ],
    };
  },
  computed: {},
  async created() {
    await this.commonStore.preloadStores();
    const pegawais = await this.pegawaiListStore.getData(null);
    this.pegawaiSource = pegawais.data;
    this.pegawaiSourceAll = pegawais.data;
    console.log("pegawaiSource", this.pegawaiSource);
  },

  methods: {
    can,
    handleTemplateDokumenChange() {
      let statusId = 0;

      if (this.templateDokumenSelected.includes("persen")) {
        //menjadi 80persen, artinya dari honor/kontrak menjadi tetap
        if (this.templateDokumenSelected === "persen80") statusId = 4;
        if (this.templateDokumenSelected === "persen100") statusId = 3;

        this.pegawaiSource = this.pegawaiSourceAll.filter(
          (pegawai) => pegawai.pegawai_statuses_id === statusId
        );
        this.clearPegawai();
      } else {
        this.pegawaiSource = this.pegawaiSourceAll.filter(
          (pegawai) =>
            pegawai.pegawai_statuses_id > 0 && pegawai.pegawai_statuses_id < 3
        );
        const validIds = _.map(this.pegawaiSource, "id"); // Extract valid IDs
        this.selectedPegawaiIds = _.filter(this.selectedPegawaiIds, (pegawai) =>
          _.includes(validIds, pegawai.id)
        );

        console.log("selectedPegawaiIds", this.selectedPegawaiIds, validIds);
      }
    },
    preview() {
      const formInstance = this.$refs.refValidation.instance;
      if (
        formInstance.validate().isValid &&
        this.selectedPegawaiIds.length > 0
      ) {
        this.isRed = false;
        this.isPreview = true;
        if (this.$refs.templateDocKp) this.childKey++;
      } else {
        if (this.selectedPegawaiIds.length === 0) {
          this.clearPegawai();
          this.isRed = true;
        }
        notify("Lengkapi konfigurasi dokumen", "error");
      }
    },

    clearPegawai() {
      this.childKey++;
      this.isPreview = false;
      this.showPegawai = "";
      this.selectedPegawaiIds = [];
    },
    handlePegawaiClick() {
      this.isRed = false;
      const result = this.selectedPegawaiIds
        .map((item) => item.nama)
        .join(", ");
      this.showPegawai = result;
    },
  },
};
</script>
